import React, { Component } from 'react';
import { Redirect } from 'react-router';
import swal from 'sweetalert2';
import { QrReader } from 'react-qr-reader';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { connect } from 'react-redux';
import '../../scss/components/pages/login_page.scss';
import logoGolden from '../../images/logo＿green.svg';

import { 
  adminLoginRequestFunc,
  switchRememberMe,
  InitAPIStatus,
  logoutSuccess
} from '../../store/action';

class LoginPage extends Component {
  constructor(props){
    super(props)
    if (localStorage && localStorage.getItem('rememberAdminName')) {
      this.state = {
        userName: process.env.REACT_APP_NODE_ENV === 'development' ? '22' : localStorage.getItem('rememberAdminName'),
        password: process.env.REACT_APP_NODE_ENV === 'development' ? '22' : '',
        data: '',
        mode:'form',
        ipAdd:''
      };
    } else {
      this.state = {
        userName: process.env.REACT_APP_NODE_ENV === 'development' ? '22' : '',
        password: process.env.REACT_APP_NODE_ENV === 'development' ? '22' : '',
        data: '',
        mode:'form',
        ipAdd:''
      };
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeUserName = this.handleChangeUserName.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleRememberCheckBox = this.handleRememberCheckBox.bind(this);
  }
  async getIPData (){
    return await axios.get('https://ipgeolocation.abstractapi.com/v1/?api_key=b1970e845a754466add8903bd91468d2')
  }
  componentDidMount(){
    axios.all([
      this.getIPData()
    ])
      .then(axios.spread((ipAddress) => {
        this.setState({ipAdd:ipAddress.data.ip_address})
      }));
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.SendAPIState === '3') {
      swal({
        type: 'error',
        title: '帳號或密碼錯誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return 
    } else if (nextProps.SendAPIState === '4') {
      swal({
        type: 'error',
        title: '員工狀態異常',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return
    }
  }
  checkinout(){
    this.setState({
      mode: 'qrcode'
    })
  }
  returnLogin(){
    this.setState({
      mode: 'form'
    })
  }
  handleSubmit(e) {
    e.preventDefault();
    let AdminObj = Object.assign({},this.state)

    if(AdminObj.userName.trim() === "" || AdminObj.password.trim() ==="") {
      swal({
        type: 'error',
        title: '帳號密碼都要記得填喔!',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      });
      return
    } 
    this.props.adminLoginRequestFunc(AdminObj);
  }

  handleChangeUserName(e) {
    this.setState({
      userName: e.target.value
    })
  }

  handleChangePassword(e) {
    this.setState({
      password: e.target.value
    })
  }

  handleRememberCheckBox() {
    this.props.switchRememberMe({
      userName: this.state.userName,
      password: this.state.password,
    })
  }

  render() {
    const { loginState,logoutSuccess } = this.props;
    const { userName, password} = this.state;
    var key = CryptoJS.enc.Utf8.parse('6k3k4jbt3hacncxvwj2zpapdpgnhmegd');  //需要和伺服器端一致，否則… 無法解密
    var iv = CryptoJS.enc.Utf8.parse('axgrpang8kekvcj2');   //需要和伺服器端一致，否則… 無法解密
    var aesEncryDecry = {
      decryptStringAES: function (strEncryptText) {
          var decrypted = CryptoJS.AES.decrypt(strEncryptText, key, {
              keySize: 128 / 8,
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
          });
          return decrypted.toString(CryptoJS.enc.Utf8);
      },
      encryptStringAES: function (strOrignText) {
          var encrypted = CryptoJS.AES.encrypt(strOrignText, key,{
              keySize: 128 / 8,
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
          });
          return encrypted.toString();
      }
  };
    if( loginState.isLogin === true ) {
      if(localStorage.getItem('all_store_id') && localStorage.getItem('all_store_id').length > 1){
        return <Redirect to='/store' />
       }else{
        if(localStorage.getItem('all_store_id').length === 1){
          return <Redirect to='/' />
        }else{
          logoutSuccess();
        }
       }
    }
    let drawForm = <form onSubmit={this.handleSubmit} className="p-login__outer-container u-form">
          <div className="form-container">
            <div className="top-header">
              <div className="text">良師塾人文食飲管理系統</div>
            </div>
            <div className="u-form__input-box">
              <i className="fas fa-mobile-alt"></i>
              <input type="text" name="account" placeholder="請輸入帳號" 
                value={userName} onChange={this.handleChangeUserName} />
            </div>
            <div className="u-form__input-box">
              <i className="fas fa-key"></i>
              <input type="password" name="password" placeholder="請輸入密碼" 
                value={password} onChange={this.handleChangePassword} autoComplete="off" />
            </div>
            <div className="tool-box">
              <div className="remember-me">
                <input id="rember-me" type="checkbox" checked={loginState.isRemberMe} 
                  onChange={this.handleRememberCheckBox}/>
                <label htmlFor="rember-me" className="check-box"></label>
                <label htmlFor="rember-me" className="rember-me">記住我</label>
              </div>
            </div>
            <button type='submit' className="login-btn">登入</button>
            {
              this.state.ipAdd === '59.120.149.173'?<button style={{backgroundColor:'green', marginTop:'4px'}} onClick={e=>this.checkinout()} type='button' className={`login-btn`}>打卡</button>
              //this.state.ipAdd === '220.130.68.57'?<button style={{backgroundColor:'green', marginTop:'4px'}} onClick={e=>this.checkinout()} type='button' className={`login-btn`}>打卡</button>
              :''
            }
            
          </div>
          <div className="sepetate"></div>
          <div className="logo-container">
            <img src={logoGolden} alt="logoGolden" />
          </div>
          
        </form>
    
    if(this.state.mode === 'qrcode'){
      drawForm = 
      <div style={{maxWidth:'75%', width:'700px'}}>
            <QrReader
      onResult={(result, error) => {
        if (!!result) {
          //console.log(result.text);
          

              axios.post(process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/Attendance/SignInOut':'https://www.liangshishu.link:46888/api/Attendance/SignInOut',{
            CellPhone:aesEncryDecry.decryptStringAES(result.text) ,
            CompanyId:"1",
            timeOffset:8
          }).then((res) => {
            if(res.data.code === 0)
              alert('打卡成功');
            else if(res.data.code === 9)
              alert('使用者不存在')
            else if(res.data.code === 13)
              alert('簽到退次數已到達上限')
            else if(res.data.code === 16)
              alert('兩次打卡須間格五分鐘')
            else if(res.data.code === 17)
              alert('休息時間不足無法打卡')
          })
          this.setState({mode:'form'})

     

  
                
          //setData(result?.text);
        }

        if (!!error) {
          console.info(error);
        }
      }}
      style={{ width: '100%' }}
    />
    <form className='className="p-login__outer-container u-form">'>
    <div className="form-container" style={{textAlign:'center'}}>
    <button style={{backgroundColor:'green', padding:'auto'}} onClick={e=>this.returnLogin()} type='button' className={`btn btn-lg`}>返回登入</button>

    </div>
    </form>
      </div>
      
    }

    return (
      <div className="p-login" style={{minWidth:'300px'}}>
        {drawForm}
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  loginState: store.loginState,
  SendAPIState: store.SendAPIStatusState,
})

export default connect(mapStateToProps,{
  adminLoginRequestFunc,
  switchRememberMe,
  InitAPIStatus,
  logoutSuccess
})(LoginPage)